import { FunctionalComponent, h } from 'preact';
import { STICKY_TAB_ID } from '../../constants';
import { TabList as StyledTabList } from './Tabs.styles';
import { TabListProps } from './interface';
import { forwardRef } from 'preact/compat';
import { useDeviceState } from '../../hooks';

export const TabList: FunctionalComponent<TabListProps> = forwardRef<HTMLDivElement, TabListProps>(
  ({ children, ariaLabel }, ref) => {
    const { isDesktop } = useDeviceState();

    return (
      <StyledTabList id={STICKY_TAB_ID} isMobile={!isDesktop} ref={ref} data-aria-label={ariaLabel} role="tablist">
        {children}
      </StyledTabList>
    );
  },
);
